/**
 * PURPOSE: Helpers para interpretar datos del usuario autenticado y construir rutas de navegación.
 * RESPONSIBILITIES: Normalizar rol, idcompany, is_one_company y detectar usuarios multi-company.
 * COLLABORATORS: src/components/Login/Login.jsx, src/pages/Companies.jsx, src/sections/CampeonatosSection.jsx
 * ROUTE: src/utils/authUser.js
 */
export const parsePositiveInt = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getUserRole = (user) => {
  const rawRole = user?.rol ?? user?.role;
  const parsed = Number(rawRole);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getUserCompanyId = (user) => parsePositiveInt(user?.idcompany);

export const isOneCompanyUser = (user) => {
  return user?.is_one_company === true || Number(user?.is_one_company) === 1;
};

export const isMultiCompanyUser = (user) => {
  const role = getUserRole(user);
  return [1, 2, 3, 4].includes(role) && !isOneCompanyUser(user);
};

export const isScopedMultiCompanyUser = (user) => {
  const role = getUserRole(user);
  return [2, 3, 4].includes(role) && !isOneCompanyUser(user);
};

/**
 * Administrador global (rol 1). Es solo una pista de INTERFAZ: decide si se ofrece una acción, nunca
 * si se permite. El backend vuelve a comprobar el rol y el alcance en cada petición. Un rol 1 con
 * is_one_company sigue siendo rol 1 aquí: el límite de compañía lo aplica el servidor (FTR-0028 D-02).
 */
export const isSuperAdmin = (user) => getUserRole(user) === 1;

/**
 * Cambio de participante 1/2 desde "Opciones avanzadas" (FTR-0039): roles 1 y 4. Pista de INTERFAZ: el backend
 * vuelve a exigir el rol, el acceso al evento y el estado del partido en cada petición.
 */
export const canReplaceMatchParticipants = (user) => [1, 4].includes(getUserRole(user));

/**
 * "Asignar camisetas" de Programación (asignación inteligente y versiones de uniformes, FTR-0046): roles 1 y 4. El
 * botón se muestra igual a todos; para el resto solo avisa. Pista de INTERFAZ: el backend exige el rol en cada
 * petición (403 ROLE_NOT_ALLOWED).
 */
export const canUseUniformAssignment = (user) => [1, 4].includes(getUserRole(user));

export const buildCampeonatosUrlByCompany = (companyId) => {
  return `/campeonatos?idcompany=${companyId}`;
};
